import { BaseComponent } from '../core/BaseComponent.js';


export class ChoicesSelect extends BaseComponent {
    constructor(selector, options = {}) {
        super(selector, options);
        this.instance = null;
        this.options = options;
    }

    exists() {
        return document.querySelector(this.selector) !== null;
    }

    init() {
        if (this.instance) {
            return;
        }
        const el = document.querySelector(this.selector);
        if (!el) {
            return;
        }

        this.instance = new TomSelect(el, {
            allowEmptyOption: true,
            create: true,
            ...this.options
        });
    }

    clear(silent) {
        if (this.instance) {
            this.instance.clear(silent);
        }
    }

    setValue(value, silent) {
        if (this.instance) {
            this.instance.setValue(value, silent);
        }
    }

    destroy() {
        if (this.instance) {
            this.instance.destroy();
            this.instance = null;
        }
    }
}